import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import TextInput from '../../../../Shared/TextInput/TextInput';
import CheckBox from '../../../../Shared/CheckBox/Checkbox';
import { setIsSubmit } from '../../saleJetBlockSlice';
import { showAppLoader, hideAppLoader } from '../../../../Shared/Loader/LoaderSlice';
import Config from "../../../../../Config";
import ThirdParty from '../../../../Shared/ThirdParty/ThirdParty';
import { buildUrlAndOpenWindow } from '../../../../../utilities/StringHelpers/StringHelpers';
import lightIcon from '../../images/light.svg';
import Image from 'app/Components/Shared/Image/image';

const PersonalInfo = (props) => {
  const [personalInfo, setPersonalInfo] = useState({
    firstName: { value: props.firstName, error: '' },
    lastName: { value: props.lastName, error: '' },
    email: { value: '', error: '' },
    isReceivingBill: { value: false },
    isReceivingAd: { value: false },
    // isConfirmTerms: { value: false, error: '' },
  });
  const [currentFocus, setCurrentFocus] = useState('firstName');
  const firstNameRef = useRef();
  const lastNameRef = useRef();
  const emailRef = useRef();
  const isExistsCustomer = props.flowType == "existsCustomer";

  useEffect(() => {
    personalInfo['isReceivingBill'] = { value: props.isDisplayCheckboxIsReceivingBill, error: '' };
    personalInfo['isReceivingAd'] = { value: props.isReceivingAd, error: '' };
    setPersonalInfo({ ...personalInfo });
  }, []);

  useEffect(() => {
    if (!props.isEmailAvailable) {
      personalInfo['email'] = { value: personalInfo.email.value, error: 'קיים כבר מנוי TV על המייל הזה, יש מייל אחר?' };
      setPersonalInfo({ ...personalInfo });
    }
  }, [props.isEmailAvailable]);

  function handleKeyDown(e, field) {
    if (e.key === 'Enter') {
      switch (field) {
        case 'fistName':
          setCurrentFocus('lastName');
          break;
        case 'lastName':
          setCurrentFocus('email');
          break;
        case 'email':
          const response = setResponse();
          props.onValid(response);
          break;
      }
    }
  }

  function handleOnChange(value, field) {
    let isValid = true;
    if (value.trim() == '' || value.length < 2) {
      personalInfo[field] = { value: value, error: 'נא להזין ערך תקין' };
      isValid = false;
    }
    else {
      switch (field) {
        case 'firstName':
        case 'lastName':
          const name = /^[א-תA-Za-z ."״()-/\'/׳]+$/;
          if (!name.test(value)) {
            personalInfo[field] = { value: value, error: 'נא להזין ערך תקין' };
            isValid = false;
          }
          break;
        case 'email':
          if (!isValidEMail(value)) {
            personalInfo[field] = { value: value, error: 'נא להזין ערך תקין' };
            isValid = false;
          }
          break;
        // case 'isConfirmTerms':
        //   if (!isValidEMail(value)) {
        //     personalInfo[field] = { value: value, error: 'אנא אשרו את תנאי ההסכם' };
        //     isValid = false;
        //   }
        //   break;
      }
    }
    if (isValid) {
      personalInfo[field] = { value: value, error: '' };
    }
    setPersonalInfo({ ...personalInfo });
  }

  function handleOnConfirmTerms(value) {
    // personalInfo['isConfirmTerms'] = { value: value, error: (!value ? 'אנא אשרו את תנאי ההסכם' : '') };
    setPersonalInfo({ ...personalInfo });
  }


  function isValidEMail(email) {
    return /^((?!\.)[\w-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/.test(email);
  }

  useEffect(() => {
    switch (currentFocus) {
      case 'firstName':
        if (firstNameRef.current) firstNameRef.current.focus();
        break;
      case 'lastName':
        if (lastNameRef.current) lastNameRef.current.focus();
        break;
      case 'email':
        if (emailRef.current) emailRef.current.focus();
        break;
    }
  }, [currentFocus]);

  useEffect(() => {
    if (props.onSubmit) {
      const validation = isValid();
      const response = setResponse(validation);
      props.onValid(response);
    }
  }, [props.onSubmit]);

  const setResponse = (isValid) => {
    let personalDetails = { firstName: personalInfo.firstName.value, lastName: personalInfo.lastName.value, identity: '', email: personalInfo.email.value, isReceivingAd: personalInfo.isReceivingAd.value, isReceivingBill: personalInfo.isReceivingBill.value };
    return { personalDetails: personalDetails, isValid: isValid };
  };

  function isValid() {
    let isValid = true;
    if (!personalInfo.firstName.value) {
      isValid = false;
      personalInfo.firstName.error = 'נא להזין שם פרטי';
      setPersonalInfo({ ...personalInfo });
    }
    if (!personalInfo.lastName.value) {
      isValid = false;
      personalInfo.lastName.error = 'נא להזין שם משפחה';
      setPersonalInfo({ ...personalInfo });
    }
    if (!personalInfo.email.value) {
      isValid = false;
      personalInfo.email.error = 'נא להזין כתובת מייל';
      setPersonalInfo({ ...personalInfo });
    }
    else if (!isValidEMail(personalInfo.email.value)) {
      isValid = false;
      personalInfo.email.error = 'נא להזין ערך תקין';
      setPersonalInfo({ ...personalInfo });
    }
    // if (props.isDisplayCheckboxTerms && !personalInfo.isConfirmTerms.value) {
    //   isValid = false;
    //   personalInfo.isConfirmTerms.error = 'אנא אשרו את תנאי ההסכם';
    //   setPersonalInfo({ ...personalInfo });
    // }
    return isValid;
  };

  function onCheck(checkboxName) {
    personalInfo[checkboxName].value = true;
    setPersonalInfo({ ...personalInfo });
  }

  function onUncheck(checkboxName) {
    personalInfo[checkboxName].value = false;
    setPersonalInfo({ ...personalInfo });
  }

  return (
    <div className='personal-info'>
      <div className='personal-info-wrapper'>
        <div className='form-wrapper'>
          {/* <div className='form-remark'> שדות עם כוכבית הם חובה </div> */}
          <div>
            <div className= 'rows-wrapper'>
              <div className='row-wrapper'>
                <TextInput
                  value={personalInfo.firstName.value}
                  error={personalInfo.firstName.error}
                  placeholder='שם פרטי'
                  id='firstName'
                  name='firstName'
                  type='text'
                  disabled={props.firstName && isExistsCustomer ? 'disabled' : ''}
                  required='required'
                  minLength='2'
                  onChange={(e) => handleOnChange(e.target.value, 'firstName')}
                  onKeyDown={(e) => handleKeyDown(e, 'firstName')}
                />
              </div>
              <div className='row-wrapper'>
                <TextInput
                  value={personalInfo.lastName.value}
                  error={personalInfo.lastName.error}
                  placeholder='שם משפחה'
                  id='lastName'
                  name='lastName'
                  type='text'
                  disabled={props.lastName && isExistsCustomer ? 'disabled' : ''}
                  required='required'
                  minLength='2'
                  onChange={(e) => handleOnChange(e.target.value, 'lastName')}
                  onKeyDown={(e) => handleKeyDown(e, 'lastName')}
                />
              </div>
            </div>
            <div className='email-wrapper'>
              <div className='title-container-email'> {Config.receivingAdTitle}</div>
              <div className='row-wrapper'>
                <TextInput
                  value={personalInfo.email.value}
                  error={personalInfo.email.error}
                  placeholder='מייל'
                  id='email'
                  name='email'
                  type='text'
                  //disabled={personalInfo.lastName.value != ''  ? '' : 'disabled'}
                  required='required'
                  onChange={(e) => handleOnChange(e.target.value, 'email')}
                  onKeyDown={(e) => handleKeyDown(e, 'email')}
                />
              </div>
              {props.isDisplayTvRemark && <p className='info-text'>כתובת הדוא״ל תשמש אתכם לכניסה {window.Config.brand_Name_HE} TV.</p>}
              <div> {Config.primaryEmailText} <a href="#" onClick={() => buildUrlAndOpenWindow(Config.primaryEmailMoreInfoUrl)} className='link'> {Config.primaryEmailMoreInfoText}</a> </div>
            </div>
            {props.isDisplayEsimRemark && <div class="info-text-with-icon"><Image src={lightIcon} alt=""/>למייל זה יישלחו גם הנחיות להפעלת ה-eSIM</div>}
            <div className='rows-wrapper checkBox'>
              {
              props.isDisplayCheckboxIsReceivingBill &&
                <div className='row-wrapper'>
                  <CheckBox
                    id='isReceivingBill'
                    checked={personalInfo.isReceivingBill.value}
                    onCheck={() => onCheck('isReceivingBill')}
                    onUncheck={() => onUncheck('isReceivingBill')}
                    label='אני רוצה לקבל את החשבונית למייל שהזנתי (במקרה בו תסיר את הסימון, תשלח החשבונית לכתובת המגורים שמילאת)'
                  />
                </div>
              }
              {
                props.isDisplayCheckboxReceivingAd &&
                <div className='row-wrapper'>
                  <CheckBox
                    id='isReceivingAd'
                    checked={personalInfo.isReceivingAd.value}
                    label= {<ThirdParty/>}
                    onCheck={() => onCheck('isReceivingAd')}
                    onUncheck={() => onUncheck('isReceivingAd')} />
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  // function openTermsInNewTab(e) {
  //   e.preventDefault();
  //   window.open(props.termsLink, '_blank').focus();
  // }

};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = {
  setIsSubmit,
  showAppLoader,
  hideAppLoader,
};

export default connect(mapStateToProps, mapDispatchToProps)(PersonalInfo);
